export interface Breakpoints {
	desktop: number;
	desktopLg: number;
	desktopMd: number;
	phoneLg: number;
	phoneSm: number;
	tablet: number;
}

export const breakpoints: Breakpoints = {
	phoneSm: 320,
	phoneLg: 600,
	tablet: 768,
	desktop: 1024,
	desktopMd: 1200,
	desktopLg: 1360,
};

export interface Media {
	l: 1024;
	m: 981;
	s: 737;
	xl: 1281;
	xs: 376;
	xxl: 1361;
}

export const media: Media = {
	l: 1024,
	m: 981,
	s: 737,
	xl: 1281,
	xs: 376,
	xxl: 1361,
};
